exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.sorting[data-v-2bba7c23] {\n  position: absolute;\n  left: 319px;\n  z-index: 1000;\n  width: 200px;\n}\n.box-body[data-v-2bba7c23] {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)\n}\n.btn[data-v-2bba7c23] {\n  background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));\n  color: white\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-2bba7c23","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/device/Devices.vue
// module id = 152
// module chunks = 0